var _rect, _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStopRailWaltti(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.5,
    y: 22,
    width: 3,
    height: 8,
    rx: 1.5,
    fill: "#333333"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 13,
    r: 11
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3998 21H9.60017C8.71627 21 8 20.2837 8 19.4003V6.60023C8 5.71629 8.71627 5 9.60017 5H22.3998C23.2837 5 24 5.71629 24 6.60023V19.4003C23.9994 20.2837 23.2832 21 22.3998 21Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6518 14.8921V9.71037C20.6518 8.59727 19.7493 6.6008 18.6362 6.6008H13.3644C12.2513 6.6008 11.3488 8.59727 11.3488 9.71037V14.8921C11.3488 16.0052 12.2513 17.4547 13.3644 17.4547H13.4807L12.9845 18.0474H12.1232L11.5763 18.631H12.4946L11.85 19.4009H13.037L13.6816 18.631H18.3179L18.9625 19.4009H20.1495L19.5049 18.631H20.4232L19.8763 18.0474H19.0161L18.5199 17.4547H18.6362C19.7493 17.4552 20.6518 16.0057 20.6518 14.8921ZM19.2831 15.5186C18.9551 15.5186 18.6893 15.2527 18.6893 14.9254C18.6893 14.5974 18.9551 14.3321 19.2831 14.3321C19.611 14.3321 19.8763 14.598 19.8763 14.9254C19.8763 15.2533 19.6104 15.5186 19.2831 15.5186ZM14.2765 7.84034H17.723V8.42398H14.2765V7.84034ZM12.717 15.5186C12.3891 15.5186 12.1238 15.2527 12.1238 14.9254C12.1238 14.5974 12.3896 14.3321 12.717 14.3321C13.0449 14.3321 13.3102 14.598 13.3102 14.9254C13.3102 15.2533 13.0449 15.5186 12.717 15.5186ZM12.3529 13.0491C12.2175 13.0124 12.1232 12.8899 12.1232 12.7494V9.64208C12.1232 9.47105 12.2621 9.33219 12.4331 9.33219H19.5658C19.7369 9.33219 19.8757 9.47105 19.8757 9.64208V12.75C19.8757 12.8905 19.782 13.013 19.646 13.0497C19.1058 13.1947 17.6727 13.3127 15.9992 13.3127C14.3256 13.3127 12.8931 13.1942 12.3529 13.0491ZM17.8291 18.0479H14.1704L14.6666 17.4552H17.3324L17.8291 18.0479Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopRailWaltti);
export default __webpack_public_path__ + "static/media/stop-rail-waltti.0de463755c28430782f9b87f309acb11.svg";
export { ForwardRef as ReactComponent };